import { format } from 'date-fns'
import {
  PsychologistSearchListParams,
  PsychologistSearchListParamsToPersistence,
} from './PsychologistSearchListMapper.types'
import { isValidDate } from '@/utils/helpersDate'

class PsychologistSearchListMapper {
  toPersistence(
    domainData: PsychologistSearchListParams,
  ): PsychologistSearchListParamsToPersistence {
    const handleDate = date => {
      if (isValidDate(date)) {
        return format(date, 'yyyy-MM-dd')
      }
    }

    return {
      idPaciente: domainData?.patientId,
      abordagem: domainData?.theoreticalApproach,
      faixasEtaria: domainData?.ageRange,
      tema: domainData?.theme,
      genero: domainData?.gender,
      nomeDoProfissional: domainData?.professional,
      disponibilidadeInicio: handleDate(domainData?.availability),
      page: domainData?.page,
      rowsPerPage: domainData?.itemsPerPage,
      searchByTriagem: domainData?.searchByScreening,
    }
  }
}

export default new PsychologistSearchListMapper()
